import React, { useRef } from "react";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import useNomeArquivoPdf from "../Utils/useNomeArquivoPdf";
import { CAMPOS_REQUISITO_LEGAL } from "./requisitosLegaisData";
import "./RelatorioRequisitosLegaisPrint.css";

const valor = (conteudo) => String(conteudo ?? "").trim() || "-";
const LARGURAS_COLUNAS_PDF = ["10%", "16%", "12%", "16%", "14%", "16%", "9%", "7%"];
const ID_QUADRO_IMPRESSAO = "quadro-impressao-requisitos-legais";

const ESTILOS_PDF_REQUISITOS_LEGAIS = `
  @page { size: A4 landscape; margin: 0; }
  * { box-sizing: border-box; }
  html, body { margin: 0; padding: 0; background: #fff; color: #071b31; font-family: Arial, sans-serif; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
  .pagina-pdf-requisitos { width: 297mm; height: 210mm; margin: 0; padding: 15mm 15mm 6px; overflow: hidden; break-after: page; page-break-after: always; }
  .pagina-pdf-requisitos:last-child { break-after: auto; page-break-after: auto; }
  table { width: 100%; border-collapse: collapse; table-layout: fixed; }
  .cabecalho-relatorio-requisitos td { border: 1px solid #153d64; padding: 5px; text-align: center; }
  .cabecalho-relatorio-requisitos td:first-child { width: 26mm; }
  .cabecalho-relatorio-requisitos td:last-child { width: 38mm; }
  .cabecalho-relatorio-requisitos img { max-width: 24mm; max-height: 14mm; }
  .cabecalho-relatorio-requisitos strong, .cabecalho-relatorio-requisitos span { display: block; }
  .cabecalho-relatorio-requisitos td:nth-child(2) strong { font-size: 16px; color: #0b4b78; }
  .cabecalho-relatorio-requisitos span { margin-top: 3px; font-size: 9px; }
  .tabela-relatorio-requisitos { font-size: 8px; }
  .tabela-relatorio-requisitos th, .tabela-relatorio-requisitos td { border: 1px solid #777; padding: 4px 3px; text-align: center; vertical-align: middle; overflow-wrap: anywhere; }
  .tabela-relatorio-requisitos th { background: #0b3f64; color: #fff; font-size: 8.2px; }
  .tabela-relatorio-requisitos .linha-cabecalho-documento > th { border: 0; padding: 0 0 4mm; background: #fff; color: #071b31; }
  .tabela-relatorio-requisitos .cabecalho-relatorio-requisitos td { border: 1px solid #153d64; padding: 5px; }
  .tabela-relatorio-requisitos tbody tr:nth-child(even) { background: #f5f7f8; }
  .tabela-relatorio-requisitos tr { break-inside: avoid; page-break-inside: avoid; }
`;

function imprimirPdfRequisitosLegais(elemento, nomeArquivo) {
  if (!elemento) return;
  const tabela = elemento.querySelector(".tabela-relatorio-requisitos");
  const cabecalhoTabela = tabela?.querySelector("thead")?.outerHTML || "";
  const definicaoColunas = Array.from(tabela?.children || []).find((elementoFilho) => elementoFilho.tagName === "COLGROUP")?.outerHTML || "";
  const corpoTabela = Array.from(tabela?.children || []).find((elementoFilho) => elementoFilho.tagName === "TBODY");
  const linhas = Array.from(corpoTabela?.children || []);
  if (!tabela || !cabecalhoTabela || linhas.length === 0) return;

  document.getElementById(ID_QUADRO_IMPRESSAO)?.remove();
  const quadroImpressao = document.createElement("iframe");
  quadroImpressao.id = ID_QUADRO_IMPRESSAO;
  quadroImpressao.title = "Impressão dos Requisitos Legais";
  Object.assign(quadroImpressao.style, { position: "fixed", right: "0", bottom: "0", width: "1px", height: "1px", border: "0", opacity: "0", pointerEvents: "none" });
  document.body.appendChild(quadroImpressao);

  const janelaImpressao = quadroImpressao.contentWindow;
  const documentoImpressao = quadroImpressao.contentDocument;
  documentoImpressao.open();
  documentoImpressao.write(`<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"><title>${nomeArquivo}</title><style>${ESTILOS_PDF_REQUISITOS_LEGAIS}</style></head><body></body></html>`);
  documentoImpressao.close();

  function criarPagina() {
    const pagina = documentoImpressao.createElement("section");
    pagina.className = "pagina-pdf-requisitos";
    pagina.innerHTML = `<table class="tabela-relatorio-requisitos">${definicaoColunas}${cabecalhoTabela}<tbody></tbody></table>`;
    documentoImpressao.body.appendChild(pagina);
    return pagina;
  }

  let paginaAtual = criarPagina();
  const imagensCabecalho = Array.from(paginaAtual.querySelectorAll("img"));
  Promise.all(imagensCabecalho.map((imagem) => imagem.complete ? Promise.resolve() : new Promise((resolve) => {
    imagem.addEventListener("load", resolve, { once: true });
    imagem.addEventListener("error", resolve, { once: true });
  }))).then(() => {
    linhas.forEach((linha) => {
      let corpoPagina = Array.from(paginaAtual.querySelector(".tabela-relatorio-requisitos").children).find((elementoFilho) => elementoFilho.tagName === "TBODY");
      corpoPagina.insertAdjacentHTML("beforeend", linha.outerHTML);
      const linhaInserida = corpoPagina.lastElementChild;
      const limiteInferior = paginaAtual.getBoundingClientRect().bottom - 6;

      if (linhaInserida.getBoundingClientRect().bottom > limiteInferior && corpoPagina.children.length > 1) {
        linhaInserida.remove();
        paginaAtual = criarPagina();
        corpoPagina = Array.from(paginaAtual.querySelector(".tabela-relatorio-requisitos").children).find((elementoFilho) => elementoFilho.tagName === "TBODY");
        corpoPagina.insertAdjacentHTML("beforeend", linha.outerHTML);
      }
    });

    janelaImpressao.onafterprint = () => quadroImpressao.remove();
    janelaImpressao.focus();
    janelaImpressao.print();
  });
}

export default function RelatorioRequisitosLegaisPrint({ cadastro, onVoltar }) {
  const nomeArquivo = "RQ-1.8-REQUISITOS-LEGAIS";
  const paginaRef = useRef(null);
  useNomeArquivoPdf(nomeArquivo);

  if (!cadastro) return null;

  return (
    <div className="relatorio-requisitos-legais-print">
      <div className="acoes-relatorio-requisitos">
        <button type="button" onClick={onVoltar}>Voltar</button>
        <button type="button" className="botao-pdf-requisitos" onClick={() => imprimirPdfRequisitosLegais(paginaRef.current, nomeArquivo)}>Salvar como PDF</button>
      </div>
      <main ref={paginaRef} className="pagina-relatorio-requisitos">
        <table className="tabela-relatorio-requisitos">
          <colgroup>{LARGURAS_COLUNAS_PDF.map((largura, indice) => <col key={indice} style={{ width: largura }} />)}</colgroup>
          <thead>
            <tr className="linha-cabecalho-documento">
              <th colSpan={CAMPOS_REQUISITO_LEGAL.length}>
                <table className="cabecalho-relatorio-requisitos">
                  <tbody><tr><td><LogoRelatorio alt="Logo da empresa" /></td><td><strong>REQUISITOS LEGAIS</strong><span>Sistema de Gestão da Qualidade</span></td><td><strong>RQ 1.8</strong><span>Revisão {valor(cadastro.revisao)}</span><span>Atualizado em {valor(cadastro.atualizadoEmDocumento)}</span></td></tr></tbody>
                </table>
              </th>
            </tr>
            <tr>{CAMPOS_REQUISITO_LEGAL.map(([campo, titulo]) => <th key={campo}>{titulo}</th>)}</tr>
          </thead>
          <tbody>{(cadastro.requisitos || []).map((requisito, indice) => <tr key={requisito.id || indice}>{CAMPOS_REQUISITO_LEGAL.map(([campo]) => <td key={campo}>{valor(requisito[campo])}</td>)}</tr>)}</tbody>
        </table>
      </main>
    </div>
  );
}
